import { useKernelApi } from 'infrastructure/api';
import { useCrudService } from 'framework/crud';

export const COMPETENCIES_URL = '/competencies';

const useCompetencyService = () => {
  const baseCrudRequests = useCrudService({
    singleResourceUrl: `${COMPETENCIES_URL}/:id`,
    listResourceUrl: COMPETENCIES_URL,
    useService: useKernelApi,
  });

  return {
    ...baseCrudRequests,
  };
};

export default useCompetencyService;
